import { useQuery } from '@tanstack/react-query'
import { locationService } from '../../../services'

// Hook para buscar cidades com estado e país aninhados
export const useCidades = () => {
  return useQuery({
    queryKey: ['cidades'],
    queryFn: async () => {
      return await locationService.getCidades()
    },
    staleTime: 1000 * 60 * 60, // 1 hora - dados raramente mudam
  })
}

// Hooks extras mantidos para uso futuro se necessário
export const usePaises = () => {
  return useQuery({
    queryKey: ['paises'],
    queryFn: async () => {
      return await locationService.getPaises()
    },
    staleTime: 1000 * 60 * 60,
  })
}

export const useEstados = () => {
  return useQuery({
    queryKey: ['estados'],
    queryFn: async () => {
      return await locationService.getEstados()
    },
    staleTime: 1000 * 60 * 60,
  })
}

export const useEstadosByPais = (paisId: number | null) => {
  return useQuery({
    queryKey: ['estados', 'pais', paisId],
    queryFn: async () => {
      if (!paisId) return []
      return await locationService.getEstadosByPais(paisId)
    },
    enabled: !!paisId,
    staleTime: 1000 * 60 * 60,
  })
}

export const useCidadesByEstado = (estadoId: number | null) => {
  return useQuery({
    queryKey: ['cidades', 'estado', estadoId],
    queryFn: async () => {
      if (!estadoId) return []
      return await locationService.getCidadesByEstado(estadoId)
    },
    enabled: !!estadoId,
    staleTime: 1000 * 60 * 60,
  })
}
